// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"f60d9265","222":"34808457","335":"4d095573","406":"b5f9f366","453":"c736fe56","767":"97a0e467","816":"f9dbfb1d","873":"9ee68a5b"}[chunkId] + ".chunk.js";
};